module.exports = __webpack_public_path__ + "img/video_node.a7938c97.png";